<div class="content-step-container">
  @if (content.title) {
    <h2 class="ion-no-margin">{{ content.title }}</h2>
  }
  <p class="ion-no-margin">{{ content.description }}</p>
</div>
